import { listPage } from '@/models/listPage';
import PeriodModel from '@/models/entities/PeriodModel';
import TimeEntryModel from '@/models/entities/TimeEntryModel';
import TimeSheetModel from '@/models/entities/TimeSheetModel';
import { loadSignatures, type Signatures } from './signatures';
import { loadReferences } from '@/stores/useReferenceOptions';
import { TIME_SHEET_SUMMARIES } from '@/models/entities/TimeSheetSummaryModel';
import { fetchSummaries } from '@/models/summaries';

/** Lignes d'une feuille chargées en une requête (maximum de l'API) */
const MAX_ENTRIES = 300;

export interface TimeSheetDetailData {
  sheet: TimeSheetModel;
  /** Pour sa société (la feuille ne l'imbrique pas) */
  period: PeriodModel;
  entries: TimeEntryModel[];
  signatures: Signatures;
}

/** Feuille, période, lignes et signatures (useLoader) ; l'historique se charge dans son bloc, paginé */
export async function loadTimeSheetDetail(id: string): Promise<TimeSheetDetailData> {
  const { model: sheet } = await new TimeSheetModel({ id }).fetch({ silentError: true });
  // Employé, équipe et total (la période est chargée ci-dessous, avec sa société) ; statuts et types lus par leur id
  await Promise.all([
    sheet.fetchResolvable('member', 'user'),
    sheet.fetchResolvable('teamMember', 'team'),
    fetchSummaries([sheet], TIME_SHEET_SUMMARIES),
    loadReferences('timeSheetStatuses', 'timeSheetTypes'),
  ]);
  const [{ model: period }, entries, signatures] = await Promise.all([
    new PeriodModel({ id: sheet.period.id }).fetch({ silentError: true }),
    listPage(TimeEntryModel, {
      filters: { timeSheet: sheet.id },
      order: { startAt: 'asc' },
      page: 1,
      itemsPerPage: MAX_ENTRIES,
      partial: true,
    }),
    loadSignatures([id]),
  ]);

  return {
    sheet,
    period,
    entries: entries.models,
    signatures: signatures.get(Number(id)) ?? { employee: null, manager: null, director: null },
  };
}
